// Numéros d'origine du site. Le script de suivi d'appels (public/js/suivi-appels.js) les remplace
// à l'affichage par un numéro de suivi : ne saisir ici que les numéros fournis pour CE site.
// Saisie : numéro national espagnol à 9 chiffres. Lien généré : tel:0034 + numéro (format attendu par le script).
// Affichage par groupes de 3 chiffres ("932 712 096"), comme le numéro de suivi affiché par le script.
// Le numéro administratif n'est jamais mis ici ni en lien tel:.

export const PHONE_CONFIG = {
  ES: {
    fibra: {
      LP: "932712096", // NOMA ES BOX - LP + Call Ext : pages + extension d'appel Google Ads
      SB: "932711694", // NOMA ES BOX - Sticky Bar : barre d'appel fixe
      LOWI: "876140358", // NOMA ES BOX - LOWI LP et SB : page /lowi-comparator uniquement
    },
  },
};

export const VERTICAL = "fibra";

const COUNTRY_PREFIX = { ES: "0034" };

function digits(type, vertical, country) {
  return PHONE_CONFIG[country][vertical][type].replace(/\D/g, "");
}

// Numéro affiché : "932 712 096"
export function getPhone(type = "LP", vertical = VERTICAL, country = "ES") {
  return digits(type, vertical, country).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

// Numéro du lien, sans "tel:" : "0034932712096"
export function getPhoneTel(type = "LP", vertical = VERTICAL, country = "ES") {
  return COUNTRY_PREFIX[country] + digits(type, vertical, country);
}

function phone(type) {
  return { href: "tel:" + getPhoneTel(type), display: getPhone(type) };
}

// Numéros par défaut : { main, sticky }.
export const PHONES = {
  main: phone("LP"),
  sticky: phone("SB"),
};

// Une page marque peut avoir son propre numéro (champ "phone" dans providersData.js) :
// il sert alors à la fois au bouton de la page et à la barre d'appel fixe.
export function phonesFor(provider) {
  if (provider && provider.phone) {
    const p = phone(provider.phone);
    return { main: p, sticky: p };
  }
  return PHONES;
}
